import HTMLimage from './Images/HTMLimage.png'
import CSSimage from './Images/CSSimage.png'
import JSimage from './Images/JSimage.png'
import Nodeimage from './Images/Nodeimage.png'
import Databaseimage from './Images/Databaseimage.png'
import Otherimage from './Images/Otherimage.png'

const skillsObject = {
    skillsArrayOne: [
        {
            title: "HTML",
            image: HTMLimage,
        },
        {
            title: "CSS",
            image: CSSimage,
        },
        {
            title: "Javascript",
            image: JSimage,
        },
    ],
    skillsArrayTwo: [
        {
            title: "Node",
            image: Nodeimage,
        },
        {
            title: "Database Technology",
            image: Databaseimage,
        },
        {
            title: "Other",
            image: Otherimage,
        },
    ]

}

export default skillsObject